module.exports = __webpack_public_path__ + "img/home_29.7cf79fb3.png";